jQuery(document).ready(function (e)
{  
	//$('.design-template2 label.variant__button-label:contains("2 Month")').click();
    $('.design-template11 label.variant__button-label:contains("1 Month")').click();
	//$('.formen-minoxidil-topical-solution-5 label.variant__button-label:contains("1 Month")').click();
	//$('label.variant__button-label:contains("2 Month")').click();
	$('.design-template1 label.variant__button-label:contains("2 Tubes")').click();
    $('.design-template2 label.variant__button-label:contains("2 Tubes")').click();
    $('.design-template22 label.variant__button-label:contains("1 Tubes")').click();
	$('label.variant__button-label:contains("2 Packs")').click();
	$('label.variant__button-label:contains("2 Qty")').click();
	//$('label.variant__button-label:contains("2 Bottles")').click();
	//$('.design-template2 label.variant__button-label:contains("2 Bottles")').click();
	$('.design-template1 label.variant__button-label:contains("2 Bottles")').click();
    $('.joymax-dotted-condoms-with-strawberry-flavors label.variant__button-label:contains("1 Pack")').click();
    //$('.joymax-ultra-thin-delay-condom label.variant__button-label:contains("1 Pack")').click();

	$('.design-template2.joymax-last-long-condom label.variant__button-label:contains("3 Packs - 30 units")').click();
	$('.design-template2.joymax-chocolate-condom label.variant__button-label:contains("3 Packs - 30 units")').click();
	$('.design-template2.joymax-strawberry-condom label.variant__button-label:contains("3 Packs - 30 units")').click();
	$('.design-template2.joymax-last-long-ultra-thin-condom label.variant__button-label:contains("3 Packs - 30")').click();

	document.addEventListener('click', function (e) {
		if (e.target.closest('.nwcampdp-ordernow_btn span')) {
			const atcBtn = document.querySelector('.payment-buttons .add-to-cart');
			if (atcBtn) {
			atcBtn.click();
			}
		}
	});

	$(document).on('click', '.allmenswellness_bannew span', function(e) {
		e.preventDefault();
		var target = $(this).data('target');
		// Activate the tab
		$('.sale_item').removeClass('current');
		$(target).addClass('current');
		$(target).trigger('click');
		// Scroll to the target
		$('html, body').animate({
			scrollTop: $(target).offset().top
		}, 500);
	});

    if (
        !$('.design-template2').hasClass('prolong-delay-spray-for-men') &&
        !$('.design-template2').hasClass('pocket-delay-spray')
    ) {
        //$('.design-template2 label.variant__button-label:contains("2 Bottles")').click(); 
    }

	$(document).ready(function () {
		$(function() {
			let isDown = false;
			let startX;
			let scrollLeft;
			const $slider = $('.prdt_customproducts_wp');
			$slider.on('mousedown', function(e) {
				isDown = true;
				$(this).addClass('dragging');
				startX = e.pageX - this.offsetLeft;
				scrollLeft = this.scrollLeft;
			});
			$slider.on('mouseleave mouseup', function() {
				isDown = false;
				$(this).removeClass('dragging');
			});
			$slider.on('mousemove', function(e) {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - this.offsetLeft;
				const walk = (x - startX) * 1.5;
				this.scrollLeft = scrollLeft - walk;
			});
		});
	});

    $(document).ready(function () {
        $('.scientificproof-popup').on('click', function () {
          $('body').addClass('popup_active');
        });
        $(document).on('click', '.scientificbg-popup .popup-modal-dismiss', function () {
          $('body').removeClass('popup_active');
        });
    }); 

	$(document).ready(function(){ 
		$(".howitworksproduct_tabs ul li").click(function(){
			var tabId = $(this).data("tab");
			$(".howitworksproduct_tabs ul li").removeClass("active");
			$(".howitworksproduct_tabscnt").removeClass("active");
			$(this).addClass("active");
			$('.howitworksproduct_tabscnt[data-tab="' + tabId + '"]').addClass("active");
		});
	});
 
	//whtasapp timer start
	function showDivBasedOnTime()
	{
		var currentTime = new Date();
		var currentHour = currentTime.getUTCHours();
		var currentMinute = currentTime.getUTCMinutes();
		var istHour = currentHour + 5;
		var istMinute = currentMinute + 30;
		if (istHour >= 24)
		{
			istHour -= 24;
		}
		if (istMinute >= 60)
		{
			istMinute -= 60;
			istHour += 1;
		}
		if ((istHour === 9 && istMinute >= 30) || (istHour > 9 && istHour < 20) || (istHour === 20 && istMinute <= 30))
		{
			var myDiv = document.getElementById('sy-whatshelp');
			myDiv.style.display = 'block';
		}
		else
		{
			var myDiv = document.getElementById('sy-whatshelp');
			myDiv.style.display = 'none';
		}
	}
	window.onload = showDivBasedOnTime;
	//whtasapp timer end

	jQuery(document).on("click", ".openaddtocart", function ()
	{
		jQuery(this).siblings('.add-to-cart').click();
	});

	e(".collapsible-content,.doctor_text").html(function (e, t)
	{
		return t.replace(/&nbsp;/g, "");
	});
	var t,
		a = e(".category_tabs");
	e(".mobilenext").click(function ()
		{
			(t = a.width() / 2 + a.scrollLeft()), a.animate(
			{
				scrollLeft: t
			});
		}),
		e("#shopify-section-template--18306737668415__1677843215c794961f").insertAfter(".main-review h2.main-heading"),
		e("#shopify-section-template--21953821999423__8fb9d405-55cd-443f-a437-8c8285883b2c .section-header__link").attr("href", "/pages/blog"),
		e(".beard-tab-menu li a").on("click", function ()
		{
			var t = e(this).attr("beard-data-rel");
			return (
				e(".beard-tab-menu li a").removeClass("active"),
				e(this).addClass("active"),
				e("#" + t)
				.fadeIn("slow")
				.siblings(".beard-tab-box")
				.hide(),
				!1
			);
		}),
		e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide(),
		e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
		e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
		e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
		e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").hide(),
		e(".category_tabs .item").on("click", function ()
		{
			var t = e(this).text();
			e(".category_tabs .item").removeClass("current"),
				e(this).addClass("current"),
				"Hair" == t &&
				(e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").show(),
					e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide(),
					e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
					e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").hide(),
					e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
					e(".testimonialssec_hide").hide()),
				"Skin" == t &&
				(e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").show(),
					e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
					e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
					e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").hide(),
					e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
					e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").hide()),
				"Beard" == t &&
				(e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").show(),
					e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide(),
					e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
					e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").hide(),
					e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
					e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").hide()),
				"Stamina" == t &&
				(e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").show(),
					e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
					e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
					e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide(),
					e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
					e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").hide()),
				"Wellness" == t &&
				(e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").show(),
					e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide(),
					e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").hide(),
					e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
					e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
					e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").hide()),
				"Personal Essentials" == t &&
				(e("#shopify-section-template--21953821999423__6ba0de41-3142-4890-8fbb-c8b89be3f562").show(),
					e("#shopify-section-template--21953821999423__0d451478-c2b1-4e82-b382-4215e000d9f6").hide(),
					e("#shopify-section-template--21953821999423__2cb3f6e1-046f-4034-91e0-4956bb3af329").hide(),
					e("#shopify-section-template--21953821999423__90962c8e-1d16-4c07-9afc-27226fdb62aa").hide(),
					e("#shopify-section-template--21953821999423__d9faa514-577a-49a2-b714-0291f4bfa81b").hide(),
					e("#shopify-section-template--21953821999423__88e073dc-40a7-4c7b-8b35-460b63b703c3").hide());
		}),
		e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
		e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
		e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
		e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
		e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
		e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
		e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
        e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide(),
		e("#shopify-section-template--18306737406271__00a962b5-0a60-4b40-af81-73d99d32f165 .category_tabs .item").on("click", function ()
		{
			var t = e(this).find("p").text();
			console.log(t),
				e("#shopify-section-template--18306737406271__00a962b5-0a60-4b40-af81-73d99d32f165.category_tabs .item").removeClass("current"),
				e(this).addClass("current"),
				"Pleasure Maxi Tablet" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").show(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Endure Max" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").show(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Genesis Max" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").show(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Testoboost Capsules" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").show(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Shilajit and Ashwagandha Tablets for Men" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").show(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Long Last Tablets" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").show(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide()),
				"Delay Spray" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").show(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide()),
				"Man Up Max Tablets" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").hide(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").show()),
                "Minoxidil Topical Solution USP 5%" == t &&
				(e("#shopify-section-template--18306737406271__a612d574-0d56-4109-bd5a-4bccbac7e429").hide(),
					e("#shopify-section-template--18306737406271__74b07764-9417-4abc-9ec3-fba56df1e4c1").hide(),
					e("#shopify-section-template--18306737406271__dd24e280-6b1e-4066-845d-769d8a76a596").hide(),
					e("#shopify-section-template--18306737406271__dda3ffab-0cb6-4213-97b7-4d29c23056db").hide(),
					e("#shopify-section-template--18306737406271__3acf08ce-48b9-40d8-aeba-25d269a9dcb7").hide(),
					e("#shopify-section-template--18306737406271__ed0c775b-3aa1-4ce0-8f88-937310814125").hide(),
					e("#shopify-section-template--18306737406271__44353b5c-9071-427a-89b6-db23942fb73f").hide(),
                    e("#shopify-section-template--18306737406271__fec099d8-a5d3-4bca-9810-ca94f7be3a54").show(),
					e("#shopify-section-template--18306737406271__cc968163-535e-41ee-b95d-3c554807cfb5").hide());
		}),
		e('#sale .payment-buttons .openaddtocart').on("click", function ()
		{
			//alert('ss');
			e('#quick-add-modal .modal__close').trigger("click");
		});
  
	    e("a").click(function ()
		  {
			return e("html, body").animate(
			{
				scrollTop: e(e(this).attr("href")).offset().top
			}, 500), !1;
		}),

       $(".ingredients_list h4").click(function() {
            var thisclass = $(this).attr("class");
            if (thisclass != "closeimg") {
                $(this).attr("class", "closeimg");
                $(this).parents(".ingredients_list").find(".ingredientstab_cnt").slideDown();
                $(this).parent(".ingredients_list").find("em").hide();
            } else {
                $(this).attr("class", "");
                $(this).parents(".ingredients_list").find(".ingredientstab_cnt").slideUp();
                $(this).parent(".ingredients_list").find("em").show()
            }
        }),

		e(".template-product .logo-bar .new-grid.product-grid").slick(
		{
			infinite: !0,
			autoplay: !0,
			slidesToShow: 7,
			slidesToScroll: 2,
			autoplaySpeed: 0,
			speed: 2e3,
			pauseOnHover: !0,
			cssEase: "linear",
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 7,
					slidesToScroll: 1,
					infinite: !0
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 4,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, ],
		}),
		e(".testimonialvideos_slider").slick(
		{
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 4,
					slidesToScroll: 1,
					infinite: !0
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 3,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}, ],
		}),
        $('.clinicalstudies_slider').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: !0 } },
                { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
            ],
        }), 
        $(".favouritecarbssugars_slider").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
        }),  
		$('.moderatetypes_slider').slick({
			dots: true,
			arrows: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			infinite: true,
			speed: 300,
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}, ],
		}),
		$('.brands-responsive').slick({
            infinite: !0,
			autoplay: !0,
			slidesToShow: 6,
			slidesToScroll: 2,
			autoplaySpeed: 0,
			speed: 2e3,
			pauseOnHover: !0,
			cssEase: "linear",
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 7,
					slidesToScroll: 1,
					infinite: !0
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 4,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, ],
		}),
		$('.scientificproof-popup').magnificPopup(
		{
			type: 'inline',
			preloader: false,
			focus: '#username',
			modal: true
		});
        $('.happyguttab_link').click(function(){
            var tab_id = $(this).attr('data-tab');
            $('.happygut_tabcontent').removeClass('active');
            $('.happyguttab_link').removeClass('active');
            $("#" + tab_id).addClass('active');
            $(this).addClass('active');
        });
	e('.popup-modal').magnificPopup(
		{
			type: 'inline',
			preloader: false,
			focus: '#name',
			closeBtnInside: false,
			closeOnContentClick: false,
			closeOnBgClick: true,
			enableEscapeKey: true,
			modal: true,
			asNavFor: ".mfp-arrow",
			gallery:
			{
				enabled: true,
				tPrev: '@T("Media.MagnificPopup.Previous")',
				tNext: '@T("Media.MagnificPopup.Next")',
			},
			callbacks:
			{
				open: function ()
				{

					var $videos = $('.white-popup-block video');
					if ($videos.length > 0)
					{
						$videos.each(function ()
						{
							this.pause();
							this.currentTime = 0;
						});
					}

					var $video = $('.mfp-content video');
					if ($video.length > 0)
					{
						$video.each(function ()
						{
							this.pause();
							this.currentTime = 0;
						});
						$video.first().get(0).play();
					}
				},
				change: function ()
				{
					console.log('newchange');
					var $videos = $('.white-popup-block video');
					if ($videos.length > 0)
					{
						$videos.each(function ()
						{
							this.pause();
							this.currentTime = 0;
						});
					}

					setTimeout(function ()
					{

						var $video = $('.mfp-content video');
						if ($video.length > 0)
						{
							console.log('innn')
							$video.first().get(0).play();
						}

					}, 200);



				},
				close: function ()
				{
					var $video = $('.white-popup-block video');
					if ($video.length > 0)
					{
						$video.each(function ()
						{
							this.pause();
							this.currentTime = 0;
						});
					}
				}
			}
		}),
		e(document).on('click', '.popup-modal-dismiss', function (e)
		{
			e.preventDefault();
			$.magnificPopup.close();
		}),
		e("#shopify-section-template--21953822064959__80e14c94-5c3c-4be2-9b5d-2320825a63ab .logo-bar .new-grid.product-grid").slick(
		{
			infinite: !0,
			autoplay: !0,
			slidesToShow: 7,
			slidesToScroll: 2,
			autoplaySpeed: 0,
			speed: 2e3,
			pauseOnHover: !0,
			cssEase: "linear",
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 7,
					slidesToScroll: 1,
					infinite: !0
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 4,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, ],
		}),
		e('.featuredinproduct').slick(
		{
			speed: 2000,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 1000,
			cssEase: 'linear',
			slidesToShow: 7,
			slidesToScroll: 1,
			initialSlide: 1,
			arrows: false,
			buttons: false,
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 769,
				settings:
				{
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, ],
		}),
		e(".main-ingredients").slick(
		{
			dots: false,
			arrows: true,
			slidesToShow: 4,
			autoplay: 0,
			slidesToScroll: 1,
			adaptiveHeight: !0,
			infinite: false,
			responsive: [
			{
				breakpoint: 1024,
				settings:
				{
					adaptiveHeight: !0,
					slidesToShow: 4
				}
			},
			{
				breakpoint: 480,
				settings:
				{
					adaptiveHeight: !0,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}, ],
		}),
		setTimeout(function ()
		{
			e(".product-recommendations a, .search-content .grid-item a").each(function ()
			{
				var t = e(this).attr("href");
				(t = t.split("?")[0].split("&")[0].split("#")[0]), e(this).attr("href", t);
			});
		}, 2e3);
	var i = e(".global-rating .countstar").val();
	e(".global-rating .star").html(
		(function e(t)
		{
			t = Math.round(2 * t) / 2;
			let a = [];
			for (var i = t; i >= 1; i--) a.push('<i class="fa fa-star" aria-hidden="true" style="color: gold;"></i>&nbsp;');
			0.5 == i && a.push('<i class="fa fa-star-half-o" aria-hidden="true" style="color: gold;"></i>&nbsp;');
			for (let _ = 5 - t; _ >= 1; _--) a.push('<i class="fa fa-star-o" aria-hidden="true" style="color: gold;"></i>&nbsp;');
			return a.join("");
		})(i)
	);

	jQuery(".onreviewpage .category_tabs").slick(
	{
		infinite: !0,
		autoplay: 0,
		slidesToShow: 8,
		slidesToScroll: 2,
		cssEase: "linear",
		responsive: [
		{
			breakpoint: 1024,
			settings:
			{
				slidesToShow: 7,
				slidesToScroll: 1,
				infinite: !0
			}
		},
		{
			breakpoint: 769,
			settings:
			{
				slidesToShow: 4,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 480,
			settings:
			{
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, ],
	});

	$("body").on("click", ".category_tabs_section .sale_item", function(){
		var getclass = $(this).attr('classtoshow');
		$('.category_tabs_section .sale_item').removeClass('current');
		$(this).addClass('current');
		$('.salepagehide').hide();
		$('.' + getclass).show();
	});
                   
	$("body").on("click", ".add-to-cart", function(){
		setTimeout(function(){
			$('.modal__close').click();
		}, 2000);
	});

	jQuery(document).ready(function($){
		//console.log("✅ Script loaded and jQuery ready");
		// When a video thumbnail is clicked
		$(document).on("click", ".testimonialvideos_list a", function(e){
			e.preventDefault();
			//console.log("🎬 Thumbnail clicked");
			var videoUrl = $(this).attr("href");
			var parentBox = $(this).parent();
			var thumbSrc = $(this).find("img").attr("src");
			//console.log("Video URL:", videoUrl);
			// 1️⃣ Stop and reset all currently playing videos
			$(".testimonialvideos_list video").each(function(){
			this.pause();
			this.currentTime = 0;
			// Restore the thumbnail for other videos
			const thumb = $(this).data("thumb");
			const src = $(this).data("src");
			if (thumb && src) {
				$(this).parent().html(`
				<a href="${src}">
					<img src="${thumb}" alt="">
				</a>
				`);
			}
			});
			// 2️⃣ Replace clicked thumbnail with new playing video
			const videoElement = `
			<video autoplay controls playsinline
					data-src="${videoUrl}"
					data-thumb="${thumbSrc}"
					style="width:100%; height:100%; border-radius:8px;">
				<source src="${videoUrl}" type="video/mp4">
				Your browser does not support the video tag.
			</video>
			`;
			parentBox.html(videoElement);
			console.log("✅ Video replaced inline and playing");
		});
	});
	
});